import React, {Component} from "react";
import classes from './MemberRegistration.module.css'
import {Container, Row, Col, Card, CardHeader, FormGroup, Label, Input, Button} from 'reactstrap'
import firebase from "../../Config/firebase";
import DatePicker from "react-datepicker";
import Select from 'react-select'
import {v4 as uuidv4} from "uuid";
import "react-datepicker/dist/react-datepicker.css";
import {withRouter} from "react-router-dom";

import common from '../../Utils/common.module.css'
import {MDBBtn, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBCard, MDBAlert} from "mdbreact";
import {connect} from "react-redux";
import {isSchoolEmail, isValidEmail} from "../../Utils/converter";
import SchoolEmailVerification from "../../Component/SchoolEmailVerification/SchoolEmailVerification";

const db = firebase.firestore()
const storageRef = firebase.storage()

const sex = [
    {value: 'notShow', label: '不顯示'},
    {value: 'M', label: '男'},
    {value: 'F', label: '女'}
]

function getAge(dateOfBirth) {
    var ageDifMs = Date.now() - dateOfBirth.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

class MemberRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            member: {
                MID: '',
                Mname: '',
                createDate: new Date(),
                email: '',
                logo: '',
                isFinish: false,
                dateOfBirth: new Date(),
                sex: '',
                myCommunityId: '',
                isTeacher: false,
            },
            disable: false,
            ageGreaterThan11: true,
            isLoaded: false
        }
    }


    async componentDidMount() {
        const memberExists = await this.getMemberExists()
        if (memberExists.exists && memberExists.isFinish) {
            //finshed registration
            this.props.history.push('/')
        } else if (memberExists.exists && !memberExists.isFinish) {
            //need to fill form
            this.setState({
                member: {
                    ...memberExists.profile,
                    dateOfBirth: new Date(memberExists.profile.dateOfBirth._seconds*1000),
                    createDate: new Date(memberExists.profile.createDate._seconds*1000)
                }
            }, () => {
                this.setState({
                    isLoaded:true
                })
            })
        } else {
            this.setState({
                member: {
                    ...this.state.member,
                    MID: this.props.auth.uid,
                    email: this.props.auth.email
                }
            }, async () => {
                const setMember = await this.setMember()
                if (setMember.success) {
                    const memberExists = await this.getMemberExists()
                    if (memberExists.exists) {
                        this.setState({
                            isLoaded: true
                        })
                    }
                }
            })
        }
    }

    getMemberExists = async () => {

        return await new Promise((resolve, reject) => {
            fetch("/api/member/get", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: this.props.auth.uid
                })
            }).then((res) => res.json()).then((finalResponse) => {
                if (finalResponse.exists) {
                    resolve({
                        exists: true,
                        isFinish: finalResponse.member.isFinish,
                        profile: finalResponse.member
                    })

                } else {
                    resolve({
                        exists: false
                    })
                }
            })
        })
    }

    setMember = async () => {
        return await new Promise((resolve, reject) => {
            fetch("/api/member/set", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: this.props.auth.uid,
                    member: this.state.member
                })
            }).then((res) => res.json()).then((finalResponse) => {
                if (finalResponse.success) {

                    resolve({
                        success: true
                    })
                }
            })
        })
    }

    uploadImageCallBack = (e) => {
        return new Promise(async (resolve, reject) => {
            const file = e.target.files[0]
            const fileName = uuidv4()
            storageRef.ref().child("memberLogo/" + fileName).put(file)
                .then(async snapshot => {

                    const downloadURL = await storageRef.ref().child("memberLogo/" + fileName).getDownloadURL()
                    console.log(downloadURL)
                    resolve({
                        success: true,
                        data: {link: downloadURL}
                    })
                })
        })
    }

    onChangeSex = (value) => {
        this.setState({
            member: {
                ...this.state.member,
                sex: value
            }
        })
    }

    onChangeUserName = (value) => {
        this.setState({
            member: {
                ...this.state.member,
                Mname: value
            }
        })
    }

    setDateOfBirth = (value) => {
        console.log(value)
        this.setState({
            member: {
                ...this.state.member,
                dateOfBirth: value
            }
        }, () => {
            if (getAge(value) > 11) {
                this.setState({
                    ageGreaterThan11: true
                })
            } else {
                this.setState({
                    ageGreaterThan11: false
                })
            }

        })
    }

    submitMember = async () => {
        await fetch("/api/member/update", {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                member: this.state.member,
                uid: this.state.member.MID
            })
        }).then((res) => res.json()).then((finalResponse) => {
            if (finalResponse.success && finalResponse.isFinish) {
                alert('submit success')
                this.props.history.push('/')
            } else {
                alert('請確定你已經填寫了所有位置及正確的出生日期')
            }
        })

    }


    render() {
        if(this.state.isLoaded){
            return (
                <div>
                    <MDBCard>

                        <MDBCardBody>
                            <h2 className={classes.Heading}>
                                😜你只差一步便完成注冊
                            </h2>
                            <FormGroup>
                                <Label className={classes.Label}>你的頭像</Label>
                                <div className={classes.icon}>
                                    {
                                        this.state.hasFeatureImage ?
                                            <img src={this.state.member.logo} className={classes.UserIcon}
                                                 alt='userIcon'/> :
                                            <img src={this.props.auth.photoURL} className={classes.UserIcon}
                                                 alt='userIcon'/>
                                    }
                                </div>


                                <Input type="file" accept="image/*" className={classes.UploadInput}
                                       onChange={async (e) => {
                                           const uploadStatus = await this.uploadImageCallBack(e)
                                           if (uploadStatus.success) {
                                               this.setState({
                                                   hasFeatureImage: true,
                                                   member: {
                                                       ...this.state.member,
                                                       logo: uploadStatus.data.link
                                                   }
                                               })
                                           }
                                       }}>
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label className={classes.Label}>你的名稱*</Label>
                                <Input type='text' name='Mname' id='Mname' placeholder=''
                                       onChange={(e) => this.onChangeUserName(e.target.value)}
                                       value={this.state.member.Mname}/>
                            </FormGroup>

                            <FormGroup>
                                <Label className={classes.Label}>你的性別*</Label>
                                <Select options={sex}
                                        onChange={(e) => this.onChangeSex(e.value)}/>
                            </FormGroup>

                            <FormGroup>
                                <Label className={classes.Label}>出生日期*</Label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    name="dayOfBirth"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={45}
                                    placeholderText="Click to select a date"
                                    className={[classes.DatePicker, new Date(this.state.member.dateOfBirth) ? "" : classes.DatePickerError].join(" ")}
                                    maxDate={new Date()}
                                    selected={new Date(this.state.member.dateOfBirth)}
                                    onChange={e => this.setDateOfBirth(e)}
                                />
                                {this.state.ageGreaterThan11 ? '' : '你需要大於11歲'}
                            </FormGroup>

                            <div className={classes.EmailValidor}>
                                <h5>你是學校的老師或學生嗎？ 在下方輸入學校的電子郵件進行驗證。</h5>
                                <ul>
                                    <li>只要驗證後的老師才可發文及留言</li>
                                    <li>只要驗證後的學生才可留言</li>
                                </ul>
                                <SchoolEmailVerification
                                    auth={this.props.auth}
                                />
                            </div>

                        </MDBCardBody>

                        <MDBCardFooter>
                            <MDBBtn color='link' disabled={this.state.disable}
                                    rounded
                                    className={['float-right', classes.FinishBtn].join(' ')}
                                    onClick={(e) => this.submitMember()}>
                                完成注冊
                            </MDBBtn>
                        </MDBCardFooter>
                    </MDBCard>

                </div>
            )
        }
        else{
           return(
               <div>
                   Loading...
               </div>
           )
        }

    }
}


const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default withRouter(enhance(MemberRegistration))